import type { OfficeCity } from '../core/models/office-city';

export interface Office {
    readonly city: OfficeCity;
    readonly mapUrl: string;
}

/**
 * What the live marketing pages state about the company in their own markup.
 *
 * **These are not the `PublicSite.*` settings, and the difference is deliberate.** The static page
 * this replaces has no API dependency at all: with the server down it still shows an address and a
 * phone number, and a crawler that never calls the API still indexes them. Fetching them would make
 * the new page *less* robust than the one it replaces and leave a crawler reading an empty contact
 * section. The settings route keeps what genuinely changes without a deploy — whether online booking
 * is open, above all — and the prose stays page content.
 */
export const company = {
    /** As dialled. The `tel:` form is derived, so the two cannot disagree. */
    phone: '+7 (707) 662-8186',
    email: 'ipotekalyk_dariger1@mail.ru',
    whatsApp: 'https://wa.me/77076628186',
    youTube: 'https://www.youtube.com/@ipotekalyk_dariger',
    instagram: 'https://www.instagram.com/ipotekalyk_dariger',
    tikTok: 'https://www.tiktok.com/@rustem_aqai'
} as const;

export const offices: readonly Office[] = [
    { city: 'Astana', mapUrl: 'https://2gis.kz/astana/firm/70000001052035768' },
    { city: 'Almaty', mapUrl: 'https://2gis.kz/almaty/firm/70000001069921998' }
];

/** `+7 (707) 662-8186` → `+77076628186`. Derived so the dialled and displayed forms cannot drift. */
export function telHref(phone: string): string {
    return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
